<template>
  <div style="width: 100%;height: 100%;" class="overflow-auto   pb-16px">
    <div>
      <el-tabs v-model="activeName" class="demo-tabs">
        <el-tab-pane label="全部" name="first" style="height: calc(100% - 48px);">
          <div class="tabcont">
            <div class="title flex items-center justify-between mb-[16px]" v-if="collectionNum > 0">
              <div class="text-ellipsis whitespace-nowrap overflow-hidden font-bold">合集</div>
              <div class="more cursor-pointer" @click="handleMore('collect')">更多</div>
            </div>
            <collectList v-if="hasQuery" :showNum="2" :searchkwords="searchkwords"
              @selectMore="openCollect($event, true)" @num="handleNum($event, 'collect')" />
            <recommendSection v-if="hasQuery" :searchkwords="searchkwords" @num="handleNum($event, 'recommend')"
              @more="handleRecommendMore($event, 'recommend')" />
            <div v-if="!collectionNum && !recommend.length">
              <el-empty description="暂无数据" />
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="合集" name="second" v-if="collectionNum">
          <div v-if="hasQuery && activeName === 'second'" class="tabcont">
            <collectList :showNum="0" :searchkwords="searchkwords" v-show="!collectitemsShow"
              @selectMore="openCollect" />
            <elementlist :searchValue="searchkwords" type="collect" :category="collectcategory"
              @back="collectitemsShow = false" v-if="collectitemsShow" />
          </div>
        </el-tab-pane>
        <el-tab-pane :label="item.name" :name="item.id" v-for="(item, index) in recommend" :key="index">
          <div v-if="hasQuery && activeName === item.id" class="tabcont">
            <elementlist :searchValue="searchkwords" type="materials" :category="{ id: item.id }" />
          </div>
        </el-tab-pane>
        <el-tab-pane label="形状" name="fifth">
          <div v-if="hasQuery && activeName === 'fifth'" class="tabcont">
            <elementlist :searchValue="searchkwords" type="svg" />
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ElTabs, ElTabPane, ElEmpty } from 'element-plus'
import { ref, nextTick, computed } from 'vue'
// @ts-ignore
import collectList from './collectList.vue'
// @ts-ignore
import recommendSection from './recommendSection.vue'
// @ts-ignore
import elementlist from './elementlist.vue'

const activeName = ref('first')
const searchkwords = ref('')
const collectitemsShow = ref(false)
const hasQuery = computed(() => searchkwords.value.trim() !== '')

const collectionNum = ref(0)
const recommend = ref<any[]>([])
const collectcategory = ref<Record<string, any>>({})
const openCollect = (item: Record<string, any>, switchTab = false) => {
  collectcategory.value = item
  if (switchTab) activeName.value = 'second'
  collectitemsShow.value = true
}
const handleRecommendMore = (item) => {
  console.log(item)
  activeName.value = item.id
  // recommend.value = (Array.isArray(num) ? num : []).filter((item: any) => item?.materials?.length > 0)
}



const handleNum = (num: any, type: string) => {
  if (type === 'collect') {
    collectionNum.value = num
  } else if (type === 'recommend') {
    recommend.value = (Array.isArray(num) ? num : []).filter((item: any) => item?.materials?.length > 0)
  }
}



const searchList = (searchValue: string) => {
  activeName.value = 'first'
  searchkwords.value = ''
  nextTick(() => {
    searchkwords.value = searchValue
  })
}
const handleMore = (type: string) => {
  if (type === 'collect') {
    activeName.value = 'second'
  } else if (type === 'recommend') {
  }
}
defineExpose({ searchList })
</script>
<style lang="scss">
.el-tabs__item.is-active {
  color: var(--color-primary) !important;
}

.el-tabs__active-bar {
  background-color: var(--color-primary) !important;
}

.tabcont {
  height: calc(100vh - 200px);
  overflow: auto;
}
</style>
